import { render, staticRenderFns } from "./SubjectAcceptModal.vue?vue&type=template&id=4904715b&"
import script from "./SubjectAcceptModal.vue?vue&type=script&lang=js&"
export * from "./SubjectAcceptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports